<template>
  <div>
    <div class="page-actions">
      <span>交易对：</span>
      <el-select v-model="coinType" placeholder="请选择交易对">
        <el-option
          v-for="item in coinList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>注册时间： </span>
      <el-date-picker
        v-model="times"
        type="daterange"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
      <a :href="downloadLink" target="_blank">导出Excel</a>
    </div>
    <el-table :data="currencies">
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="amount" label="交易量"></el-table-column>
      <el-table-column prop="count" label="交易笔数"></el-table-column>
      <el-table-column
        prop="btcCount"
        label="持有BTC用户(当天期末)"
      ></el-table-column>
      <el-table-column prop="userId" label="最多交易用户"></el-table-column>
      <el-table-column prop="userAmount" label="该用户交易量"></el-table-column>
      <el-table-column
        prop="userPercent"
        label="该用户交易占比(%)"
      ></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import Pagination from 'components/pagination';

export default {
  name: 'tradeStatistics',
  data() {
    return {
      times: [],
      coinType: ''
    };
  },

  computed: {
    ...mapState('tradeStatistics', [
      'currencies',
      'pagination',
      'totalCount',
      'coinList'
    ]),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    },
    downloadLink() {
      const data = {
        from: this.startTime,
        to: this.endTime,
        pair: this.coinType
      };
      const params = qs.stringify(data);
      return `/la/admin/tradeStatistical/export?${params}`;
    }
  },
  methods: {
    ...mapActions('tradeStatistics', ['list']),
    ...mapMutations('tradeStatistics', ['setpage']),
    search(data) {
      if (this.times == '' || this.coinType == '') {
        this.$message.error('交易对和时间都是必填项哦');
        return;
      }
      this.list({
        from: this.startTime,
        to: this.endTime,
        pair: this.coinType,
        ...this.pagination,
        ...data
      });
    },
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', { pagination, pair: this.coinType });
    }
  },
  components: {
    Pagination
  }
};
</script>

<style lang="less" scoped></style>
